import React from 'react';

import { EventPerformance, timeData } from '../../models/models';

import EventService from '../../services/event.service';

import config from '../../config/config';

import { SCRUDRenderComponent } from '../utilities/SCRUD/SCRUD';

const { periods, weekdays, months, daysPerMonth, years, dates, times } = timeData;

type EventListItemProps = {
  event: EventPerformance;
}

const EventSCRUDRender: React.FC<SCRUDRenderComponent<EventPerformance>> = ({ initModel }) => {

  const [periodPhrase, setPeriodPhrase] = React.useState<string>('');

  React.useEffect(() => {
    (async () => {
      // strange bug event days and years are sometimes strings but should be numbers instead
      setPeriodPhrase((await EventService.periodPrases({
        day: parseInt(initModel.day.toString()),              
        month: initModel.month,
        year: parseInt(initModel.year.toString()),
        period: initModel.period
      })).body || '');
      
    })();
  }, []);

  return (
    <li className="flex p-4 shadow-md text-left">
      <div className="flex-shrink-0 w-20 h-20 mr-4">
        <img src={
          (
            initModel.thumbnail.toUpperCase().startsWith('HTTP://') ||
            initModel.thumbnail.toUpperCase().startsWith('HTTPS://') ||
            initModel.thumbnail.toUpperCase().startsWith('www.')
          ) ?
            initModel.thumbnail
          :
            config.ASSETS[config.ENVIRONMENT] + initModel.thumbnail
        } alt="Event Thumbnail" className="object-cover w-full h-full rounded" />
      </div>
      <div className="flex-grow">
        { !(initModel.period === 'Once') &&
          <div className='text-lg font-semibold text-black'>
            { periodPhrase }
            <span className='text-md text-gray-600'>,&nbsp;starting&nbsp;</span>
          </div>
        }
        <div className="flex items-center mb-2 space-x-2">
          <div className="text-lg font-semibold">{initModel.month} {initModel.day}, {initModel.year}</div>
          <div className="text-gray-600">{` at ${initModel.time}`}</div>
        </div>
        <div className='flex space-x-4 mb-2'>
          <div className="text-lg font-medium text-center">{
              initModel.website ?
                <a target="_blank" rel="noopener noreferrer" href={initModel.website}>{initModel.location}</a>
              :
                initModel.location
          }</div>
          {
            (!!initModel.addressa) && (
              <div className="text-blue-800 mt-1">{initModel.addressa}</div>
            )
          }
          {
            (!!initModel.addressb) && (
              <div className="text-blue-800 mt-1">{initModel.addressb}</div>
            )
          }
        </div>

        <div className="text-gray-700 mb-4">{initModel.description}</div>
        {/* <a href={initModel.website} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
          Learn More
        </a> */}
      </div>
    </li>
  );
};

export default EventSCRUDRender;
